import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

const fetcher = (...args: any[]) => {
	if (args[0]?.includes('undefined')) {
		return []
	}
	try {
		// @ts-ignore
		return fetch(...args).then((res) => res.json())
	} catch {
		return []
	}
}

export default function useRunes(): {
	data: any[]
	isLoading: boolean
} {
	return useSwr(`${API_URL}/rune`, fetcher)
}
